/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Mechanism/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import App from './App/index'
import Email from './Email/index'
import No from './No/index'
import React from 'react'
import Sms from './Sms/index'



/** @type {import('Simple/types.js').View} */
export default function Mechanism({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/TwoFactorAuth/Mechanism"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let resetPasswordConfirmMfaTypeValueData = fromData.useDataFormat({ viewPath,
context: 'reset_password_confirm',
path: 'mfa.type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: resetPasswordConfirmMfaTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'App'}>
<App
  viewPath={`${viewPath}/App`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Email'}>
<Email
  viewPath={`${viewPath}/Email`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sms'}>
<Sms
  viewPath={`${viewPath}/Sms`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}